
import { useEffect, useState } from "react";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { api } from "../../../../utils/api";
import Selector from "../../common/selector/Selector";
import Day from "./Day";

export default function VisitSection({ isDesktop }) {
	const [days, setDays] = useState([]);
	const [selectedDay, setSelectedDay] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchDays();
	}, []);

	function fetchDays() {
		api.visitDoctorViewDayVisits({
			token: LoginHelper.getToken(),
		}).then((results) => {
			setDays(results);
			initSelectedDay(results);
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	function initSelectedDay(days) {
		const today = days.find(day => day.is_today);
		if (today) {
			setSelectedDay(today);
		}
	}

	function handleSelectDay(dayId) {
		const day = days.find(currentDay => currentDay.id === dayId);
		if (day) {
			setSelectedDay(day);
		}
	}

	function handleToggleVisitActive(dayId, startDatetime, isActive) {
		const day = days.find(currentDay => currentDay.id === dayId);
		if (day) {
			for (let visit of day.visit_data_list) {
				if (visit.start_datetime === startDatetime) {
					visit.is_active = isActive;
					break;
				}
			}
		}
	}

	return (
		<div>
			{days && (
				<Selector isDesktop={isDesktop} days={days} selectedDay={selectedDay} onSelectDay={handleSelectDay} />
			)}
			<div className="spacer p-[10px]"></div>
			{selectedDay && (
				<Day key={selectedDay.id} isDesktop={isDesktop} day={selectedDay} onToggleVisitActive={handleToggleVisitActive} />
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
